import {
    GET_PROPERTY_MEMBERS,
    GET_PROPERTY_DEVICES_SUCCESS,
    GET_PROPERTY_DEVICES_FAILURE,
    CHECK_DEVICE_EXISTS,
    SET_DEVICE_EXISTS_VALIDATION_RESULT
} from '../actions/types';

const INITIAL_STATE = {
    error: null,
    devices: null,
    isDeviceExists: null,
    deviceExistsValidationError: null,
    deviceExistsValidationChecked: false
};

const deviceOperationsReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case GET_PROPERTY_MEMBERS:
            return {
                ...state,
                error: null
            };
        case GET_PROPERTY_DEVICES_SUCCESS:
            return {
                ...state,
                devices: action.payload
            };
        case GET_PROPERTY_DEVICES_FAILURE:
            return {
                ...state,
                error: action.payload
            };
        case CHECK_DEVICE_EXISTS:
            return {
                ...state,
                isDeviceExists: null,
                deviceExistsValidationError: null,
                // Reset so the modal's wait-for-result subscription can't resolve on
                // an unrelated store update with the previous check's answer.
                deviceExistsValidationChecked: false
            };
        case SET_DEVICE_EXISTS_VALIDATION_RESULT:
            return {
                ...state,
                isDeviceExists: action.payload.isValid,
                deviceExistsValidationChecked: true,
                deviceExistsValidationError: action.payload.errorMessage
            };
        default:
            return state;
    }
};

export default deviceOperationsReducer;
